import DragItem from '../../ddTxtImg/model/DragItem'
import DropItem from '../../ddTxtImg/model/DropItem'
class WordOnImgDropItem extends DropItem {

    constructor() {

        super()
        this.dropTxt = ""
        this.dropImg = ""
        this.IMG_TYPE=0;
        this.TXT_TYPE=1;
        this.dropType=this.TXT_TYPE
        this.dragList = []
        this.x = 50
        this.y = 50
        this.w = 150
        this.h = 60
        this.color =  "black"

    }


    getAsJson = () => {
        let obj = {}
        obj.dropTxt = this.dropTxt

        obj.x = this.x
        obj.y = this.y
        obj.w = this.w
        obj.h = this.h
        obj.solvedDragItem = this.solvedDragItem.getAsJson()

        obj.dragList = []
        for (let i = 0; i < this.dragList.length; i++) {
            obj.dragList.push(this.dragList[i].getAsJson())
        }

        return obj
    }


    initFromJson = (obj) => {
        console.log("initFromJson")
        console.log(obj)

        this.dropTxt = obj.dropTxt
        this.solvedDragItem = obj.solvedDragItem
        this.x = obj.x
        this.y = obj.y
        this.w = obj.w
        this.h = obj.h
        this.color = obj.color
        for (let i = 0; i < obj.dragList.length; i++) {
            let dragItem = new DragItem()
            dragItem.initFromJson(obj.dragList[i])
            this.dragList.push(dragItem)
        }
    }

    getReportAsJson=()=>{
        let obj={}
      

        return this.getAsJson()
    }


    initReportFromJson=(obj)=>{
       this.initFromJson(obj)
    }
}

export default WordOnImgDropItem